import { RouterStateSnapshot } from '@angular/router';
import { IRouteState } from '@firebird-web/route-store';
import { RouterStateSerializer } from '@ngrx/router-store';

export class CustomRouteSerializer
  implements RouterStateSerializer<IRouteState>
{
  serialize(routerState: RouterStateSnapshot): IRouteState {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    // Only return an object including the URL, params and query params
    // instead of the entire snapshot
    return { url, params, queryParams };
  }
}
